/**
 * Personal CTA service — the logged-in user's own attribution CTA.
 *
 * Backed by the SECURITY DEFINER RPC get_or_create_my_personal_cta, which lazily mints the
 * caller's attribution code + a default member-signup CTA on first call and returns it. The
 * reward/attribution mechanism (turning link clicks into owner credit) is deferred — see
 * docs/PLAN_PERSONAL_CTA_ATTRIBUTION.md. The link itself is a real, shareable signup link.
 */
import { supabase } from "./supabase";

export interface PersonalCta {
  // code + generated_url are null when the CTA is disabled (is_active=false) — the RPC
  // withholds all shareable material for a disabled CTA (audit R3 F6).
  code: string | null;
  cta_type: string;
  generated_url: string | null;
  qr_code_url: string | null;
  is_active: boolean;
}

export async function getOrCreateMyPersonalCta(): Promise<PersonalCta> {
  const { data, error } = await supabase.rpc("get_or_create_my_personal_cta");
  if (error) {
    throw error;
  }
  return data as PersonalCta;
}
